export default "__VITE_ASSET__D2Xz2TYt__"